import {
  activeInactiveStatus,
  added_not_added_to_lead,
  bca_status,
  biomaxStatus,
  daysAgo,
  daysAgoUptoYear,
  fitnessProfileStatus,
  payment_location,
  paymentModes,
  pt_plan_status,
  ptTrials,
  ptTrialStatuses,
  recurringStatus,
  regularPlanDurationsDropdwon,
  subscriptionTypes,
  three_day_pt_trial_session_status,
  timeSlots,
  tmeStatus,
  withinDays,
} from "../../../common-data/DropdowData";

export const SEGMENT_META_DATA = {
  segmentTypes: ["Renewal", "Unpaid", "Cart Abandoned", "Freemium"],
};

export const SEGMENT_SPECIFIC_RULES = {
  Renewal: [
    {
      label: "Trainer Name",
      value: "trainer_id",
      inputType: "select",
      options: [],
    },
    {
      label: "Added By",
      value: "added_by",
      inputType: "select",
      options: [],
    },

    {
      label: "Member Check-in Date",
      value: "member_checkin_date",
      inputType: "date-range",
    },
    {
      label: "Trainer Checkin date",
      value: "trainer_checkin_date",
      inputType: "date-range",
    },
    {
      label: "Expiring In Date",
      value: "expiring_in_date",
      inputType: "date-range",
    },
    {
      label: "Subscription Add Date",
      value: "subscription_add_date",
      inputType: "date-range",
    },

    {
      label: "Gym Name",
      value: "gym_id",
      inputType: "multi-select",
      options: [],
    },
    {
      label: "Member Checkin Time",
      value: "member_checkin_time",
      inputType: "multi-select",
      options: timeSlots,
    },
    {
      label: "Trainer Checkin Time",
      value: "trainer_checkin_time",
      inputType: "multi-select",
      options: timeSlots,
    },

    {
      label: "Member Checkin Day",
      value: "member_checkin_day",
      inputType: "select",
      options: daysAgo,
    },
    {
      label: "Trainer Checkin Day",
      value: "trainer_checkin_day",
      inputType: "select",
      options: daysAgo,
    },

    {
      label: "Regular Plan Status",
      value: "regular_plan_status",
      inputType: "select",
      options: regularPlanDurationsDropdwon,
    },
    {
      label: "PT Plan Status",
      value: "pt_plan_status",
      inputType: "select",
      options: pt_plan_status,
    },
    {
      label: "Expiring In (Days)",
      value: "expiring_in",
      inputType: "select",
      options: withinDays,
    },
    {
      label: "Recurring Status",
      value: "recurring",
      inputType: "select",
      options: recurringStatus,
    },
    {
      label: "Added to LMS",
      value: "added_to_lms",
      inputType: "select",
      options: added_not_added_to_lead,
    },
    {
      label: "Payment Mode",
      value: "payment_mode",
      inputType: "select",
      options: paymentModes,
    },
    {
      label: "Biomax Register Status",
      value: "biomax_register_status",
      inputType: "select",
      options: biomaxStatus,
    },
    {
      label: "Biomax Register First Step (App Status)",
      value: "biomax_register_first_step_app_status",
      inputType: "select",
      options: biomaxStatus,
    },
    {
      label: "TME Status",
      value: "tme_status",
      inputType: "select",
      options: tmeStatus,
    },
    {
      label: "Membership Type",
      value: "membership_type",
      inputType: "select",
      options: subscriptionTypes,
    },
    {
      label: "Plan Type",
      value: "plan_type",
      inputType: "select",
      options: regularPlanDurationsDropdwon,
    },
    {
      label: "3 Day PT Trial Status",
      value: "three_day_pt_trial_status",
      inputType: "select",
      options: ptTrials,
    },
    {
      label: "3 Day PT Trial Session Status",
      value: "three_day_pt_trial_session_status",
      inputType: "select",
      options: three_day_pt_trial_session_status,
    },
    {
      label: "Payment Location",
      value: "payment_location",
      inputType: "select",
      options: payment_location,
    },
    {
      label: "BCA Status",
      value: "bca_status",
      inputType: "select",
      options: bca_status,
    },
    {
      label: "Fitness Profile Status",
      value: "fitness_profile_status",
      inputType: "select",
      options: fitnessProfileStatus,
    },
    {
      label: "Membership Status",
      value: "membership_status",
      inputType: "select",
      options: activeInactiveStatus,
    },
  ],
  Unpaid: [
    {
      label: "Trainer Name",
      value: "trainer_id",
      inputType: "select",
      options: [],
    },
    {
      label: "Added By",
      value: "added_by",
      inputType: "select",
      options: [],
    },

    {
      label: "Member Check-in Date",
      value: "member_checkin_date",
      inputType: "date-range",
    },
    {
      label: "Trainer Checkin date",
      value: "trainer_checkin_date",
      inputType: "date-range",
    },
    {
      label: "Expiring In Date",
      value: "expiring_in_date",
      inputType: "date-range",
    },
    {
      label: "Subscription Add Date",
      value: "subscription_add_date",
      inputType: "date-range",
    },

    {
      label: "Gym Name",
      value: "gym_id",
      inputType: "multi-select",
      options: [],
    },
    {
      label: "Member Checkin Time",
      value: "member_checkin_time",
      inputType: "multi-select",
      options: timeSlots,
    },
    {
      label: "Trainer Checkin Time",
      value: "trainer_checkin_time",
      inputType: "multi-select",
      options: timeSlots,
    },

    {
      label: "Member Checkin Day",
      value: "member_checkin_day",
      inputType: "select",
      options: daysAgo,
    },
    {
      label: "Trainer Checkin Day",
      value: "trainer_checkin_day",
      inputType: "select",
      options: daysAgo,
    },

    {
      label: "Regular Plan Status",
      value: "regular_plan_status",
      inputType: "select",
      options: regularPlanDurationsDropdwon,
    },
    {
      label: "PT Plan Status",
      value: "pt_plan_status",
      inputType: "select",
      options: pt_plan_status,
    },
    {
      label: "Expired Days Ago",
      value: "expired_days_ago",
      inputType: "select",
      options: daysAgoUptoYear,
    },
    {
      label: "Recurring Status",
      value: "recurring",
      inputType: "select",
      options: recurringStatus,
    },
    {
      label: "Added to LMS",
      value: "added_to_lms",
      inputType: "select",
      options: added_not_added_to_lead,
    },
    {
      label: "Payment Mode",
      value: "payment_mode",
      inputType: "select",
      options: paymentModes,
    },
    {
      label: "Biomax Register Status",
      value: "biomax_register_status",
      inputType: "select",
      options: biomaxStatus,
    },
    {
      label: "Biomax Register First Step (App Status)",
      value: "biomax_register_first_step_app_status",
      inputType: "select",
      options: biomaxStatus,
    },
    {
      label: "TME Status",
      value: "tme_status",
      inputType: "select",
      options: tmeStatus,
    },
    {
      label: "Membership Type",
      value: "membership_type",
      inputType: "select",
      options: subscriptionTypes,
    },
    {
      label: "Plan Type",
      value: "plan_type",
      inputType: "select",
      options: regularPlanDurationsDropdwon,
    },
    {
      label: "3 Day PT Trial Status",
      value: "three_day_pt_trial_status",
      inputType: "select",
      options: ptTrials,
    },
    {
      label: "3 Day PT Trial Session Status",
      value: "three_day_pt_trial_session_status",
      inputType: "select",
      options: three_day_pt_trial_session_status,
    },
    {
      label: "Payment Location",
      value: "payment_location",
      inputType: "select",
      options: payment_location,
    },
    {
      label: "BCA Status",
      value: "bca_status",
      inputType: "select",
      options: bca_status,
    },
    {
      label: "Fitness Profile Status",
      value: "fitness_profile_status",
      inputType: "select",
      options: fitnessProfileStatus,
    },
    {
      label: "Membership Status",
      value: "membership_status",
      inputType: "select",
      options: activeInactiveStatus,
    },
  ],
  "Cart Abandoned": [
    {
      label: "Added By",
      value: "added_by",
      inputType: "select",
      options: [],
    },
    {
      label: "Date Added",
      value: "date_added",
      inputType: "date-range",
    },

    {
      label: "Gym Name",
      value: "gym_id",
      inputType: "multi-select",
      options: [],
    },

    {
      label: "Membership Type",
      value: "membership_type",
      inputType: "select",
      options: subscriptionTypes,
    },
    {
      label: "Plan Type",
      value: "plan_type",
      inputType: "select",
      options: regularPlanDurationsDropdwon,
    },
    {
      label: "Membership Status",
      value: "membership_status",
      inputType: "select",
      options: activeInactiveStatus,
    },
    {
      label: "Payment Mode",
      value: "payment_mode",
      inputType: "select",
      options: paymentModes,
    },
  ],
};

export const RULE_BUILDER_DATA = {
  fields: ["User Property", "Event Property", "App Usage", "User"],
  operators: {
    string: ["equals", "not equals", "contains", "does not contain"],
    date: ["equals", "before", "after", "between"],
    number: ["equals", "greater than", "less than"],
  },
  valueMap: {
    "User Property": {
      type: "dropdown",
      options: ["Email", "Name", "Phone", "Plan", "Location"],
    },
    "Event Property": {
      type: "dropdown",
      options: ["Subscription End Date", "Last Seen", "Purchase Value"],
    },
    "App Usage": {
      type: "dropdown",
      options: ["UTM Source", "App Version"],
    },
    User: {
      type: "dropdown",
      options: ["Plan"],
    },
  },
};

export const validateSegmentForm = (values) => {
  let errors = {};

  if (!values.segmentName) {
    errors.segmentName = "Segment name is required!";
  }

  if (!values.selectedSegmentType?.value) {
    errors.selectedSegmentType = "Segment type is required!";
  }

  if (!values.description) {
    errors.description = "Description is required!";
  }

  if (!values.selectedRules?.length) {
    errors.selectedRules = "At least one rule is required!";
  }

  if (values.selectedRules?.length > 0) {
    values.selectedRules.forEach((rule) => {
      const ruleValue = rule.value;
      const conditionValue = values.selectedRuleConditions[ruleValue];

      let isValid = false;

      if (rule.inputType === "select") {
        isValid = conditionValue && conditionValue.value;
      } else if (rule.inputType === "multi-select") {
        isValid = Array.isArray(conditionValue) && conditionValue.length > 0;
      } else if (rule.inputType === "date-range") {
        isValid = conditionValue && conditionValue.from && conditionValue.to;
      } else if (
        rule.inputType === "text" ||
        rule.inputType === "number" ||
        rule.inputType === "date" ||
        rule.inputType === "time"
      ) {
        isValid =
          conditionValue &&
          typeof conditionValue === "string" &&
          conditionValue.trim() !== "";
      } else {
        isValid = conditionValue;
      }

      if (!isValid) {
        errors[`rule_${ruleValue}`] = `${rule.label} condition is required!`;
      }
    });
  }

  return errors;
};

export const MOCK_SEGMENTS_API_RESPONSE = [
  {
    uid: "seg_001",
    segment_name: "High Value Renewal Members",
    segment_type: "Renewal",
    segment_type_id: "renewal_001",
    description: "Members with premium plans expiring in next 30 days who have high engagement",
    rules: [
      { name: "membership_type", value: "premium" },
      { name: "expiring_in", value: "30" },
      { name: "member_checkin_day", value: "7" },
      { name: "payment_mode", value: "online" }
    ],
    status: "active"
  },
  {
    uid: "seg_002",
    segment_name: "Inactive Unpaid Members",
    segment_type: "Unpaid",
    segment_type_id: "unpaid_001",
    description: "Members with outstanding payments who haven't checked in for over 30 days",
    rules: [
      { name: "expired_days_ago", value: "30" },
      { name: "member_checkin_day", value: "30" },
      { name: "payment_mode", value: "cash" },
      { name: "membership_status", value: "inactive" }
    ],
    status: "active"
  },
  {
    uid: "seg_003",
    segment_name: "Cart Abandoned Premium",
    segment_type: "Cart Abandoned",
    segment_type_id: "cart_001",
    description: "Users who abandoned premium membership carts in last 7 days",
    rules: [
      { name: "membership_type", value: "premium" },
      { name: "date_added", value: { from: "2024-01-01", to: "2024-01-07" } },
      { name: "payment_mode", value: "online" }
    ],
    status: "active"
  },
  {
    uid: "seg_004",
    segment_name: "Trainer Engagement Segment",
    segment_type: "Renewal",
    segment_type_id: "renewal_002",
    description: "Members whose trainers are highly active and members are due for renewal",
    rules: [
      { name: "trainer_checkin_day", value: "3" },
      { name: "expiring_in", value: "15" },
      { name: "pt_plan_status", value: "active" },
      { name: "trainer_checkin_time", value: ["morning", "evening"] }
    ],
    status: "inactive"
  },
  {
    uid: "seg_005",
    segment_name: "Biomax Registered Members",
    segment_type: "Renewal",
    segment_type_id: "renewal_003",
    description: "Members who have completed Biomax registration and are up for renewal",
    rules: [
      { name: "biomax_register_status", value: "completed" },
      { name: "expiring_in", value: "45" },
      { name: "fitness_profile_status", value: "completed" },
      { name: "added_to_lms", value: "yes" }
    ],
    status: "active"
  },
  {
    uid: "seg_006",
    segment_name: "Weekend Warriors",
    segment_type: "Unpaid",
    segment_type_id: "unpaid_002",
    description: "Members who only check in on weekends and have pending payments",
    rules: [
      { name: "member_checkin_time", value: ["weekend"] },
      { name: "expired_days_ago", value: "15" },
      { name: "payment_location", value: "branch" },
      { name: "recurring", value: "monthly" }
    ],
    status: "active"
  },
  {
    uid: "seg_007",
    segment_name: "Corporate Membership Renewals",
    segment_type: "Renewal",
    segment_type_id: "renewal_004",
    description: "Corporate members with bulk subscriptions expiring soon",
    rules: [
      { name: "membership_type", value: "corporate" },
      { name: "expiring_in", value: "60" },
      { name: "payment_mode", value: "corporate_billing" },
      { name: "added_by", value: "corporate_admin" }
    ],
    status: "active"
  },
  {
    uid: "seg_008",
    segment_name: "PT Trial Dropouts",
    segment_type: "Cart Abandoned",
    segment_type_id: "cart_002",
    description: "Users who started PT trial but didn't complete the process",
    rules: [
      { name: "three_day_pt_trial_status", value: "started" },
      { name: "three_day_pt_trial_session_status", value: "incomplete" },
      { name: "date_added", value: { from: "2024-01-01", to: "2024-01-15" } }
    ],
    status: "inactive"
  },
  {
    uid: "seg_009",
    segment_name: "Early Morning Fitness Enthusiasts",
    segment_type: "Renewal",
    segment_type_id: "renewal_005",
    description: "Members who consistently check in early morning and are due for renewal",
    rules: [
      { name: "member_checkin_time", value: ["early_morning"] },
      { name: "expiring_in", value: "20" },
      { name: "member_checkin_day", value: "5" },
      { name: "regular_plan_status", value: "active" }
    ],
    status: "active"
  },
  {
    uid: "seg_010",
    segment_name: "High Outstanding Amount Members",
    segment_type: "Unpaid",
    segment_type_id: "unpaid_003",
    description: "Members with significant outstanding amounts and inactive status",
    rules: [
      { name: "outstanding_amount", value: "5000" },
      { name: "membership_status", value: "inactive" },
      { name: "expired_days_ago", value: "90" },
      { name: "payment_mode", value: "installment" }
    ],
    status: "active"
  },
  {
    uid: "seg_011",
    segment_name: "TME Qualified Members",
    segment_type: "Renewal",
    segment_type_id: "renewal_006",
    description: "Members qualified for TME program with upcoming renewals",
    rules: [
      { name: "tme_status", value: "qualified" },
      { name: "expiring_in", value: "30" },
      { name: "fitness_profile_status", value: "completed" },
      { name: "member_checkin_day", value: "10" }
    ],
    status: "active"
  },
  {
    uid: "seg_012",
    segment_name: "BCA Program Participants",
    segment_type: "Renewal",
    segment_type_id: "renewal_007",
    description: "Members enrolled in BCA program with active status",
    rules: [
      { name: "bca_status", value: "enrolled" },
      { name: "expiring_in", value: "25" },
      { name: "recurring", value: "quarterly" },
      { name: "payment_location", value: "online" }
    ],
    status: "inactive"
  },
  {
    uid: "seg_013",
    segment_name: "Freemium to Premium Conversion",
    segment_type: "Cart Abandoned",
    segment_type_id: "cart_003",
    description: "Freemium users who added premium plans to cart but didn't complete",
    rules: [
      { name: "membership_type", value: "freemium" },
      { name: "cart_value", value: "5000" },
      { name: "date_added", value: { from: "2024-01-01", to: "2024-01-10" } },
      { name: "payment_mode", value: "online" }
    ],
    status: "active"
  },
  {
    uid: "seg_014",
    segment_name: "Long-term Loyal Members",
    segment_type: "Renewal",
    segment_type_id: "renewal_008",
    description: "Members with 2+ years of continuous membership",
    rules: [
      { name: "subscription_add_date", value: { from: "2022-01-01", to: "2022-12-31" } },
      { name: "expiring_in", value: "15" },
      { name: "membership_status", value: "active" },
      { name: "recurring", value: "annual" }
    ],
    status: "active"
  },
  {
    uid: "seg_015",
    segment_name: "New Location Members",
    segment_type: "Unpaid",
    segment_type_id: "unpaid_004",
    description: "Members from newly opened gym locations with payment issues",
    rules: [
      { name: "gym_id", value: ["new_location_1", "new_location_2"] },
      { name: "expired_days_ago", value: "7" },
      { name: "added_by", value: "new_trainer" },
      { name: "membership_status", value: "inactive" }
    ],
    status: "active"
  }
];
